import { useState, useEffect } from "react";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";

const EditFeature = ({ setEditPakej, featureId }) => {
  const [formData, setFormData] = useState({
    pakej: "",
    sale_price: "",
    normal_price: "",
    product_id: "",
    tema: 0,
    music: 0,
    contacts: 0,
    direction: 0,
    countdown: 0,
    rsvp: 0,
    money_gift: 0,
    guestbook: 0,
    galleries: 0,
    pdf: 0,
  });

  // Fetch existing feature data
  useEffect(() => {
    const fetchFeature = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/features/${featureId}`);
        setFormData(response.data);
      } catch (error) {
        console.error("Error fetching feature:", error);
      }
    };

    fetchFeature();
  }, [featureId]);

  // Handle text input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle toggle change
  const handleToggle = (field) => {
    setFormData((prev) => ({ ...prev, [field]: prev[field] === 1 ? 0 : 1 }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/features/${featureId}`, formData);
      await axios.put(`${process.env.REACT_APP_PAY_BASE_URL}/wp-json/wc/v3/products/${formData.product_id}`, {
        regular_price: formData.sale_price.toString(),
      }, {
        auth: {
          username: `${process.env.REACT_APP_PAY_AUTH_USERNAME}`,
          password: `${process.env.REACT_APP_PAY_AUTH_PASS}`
        }
      });
      alert("Feature updated successfully!");
    } catch (error) {
      console.error("Error updating feature:", error);
      alert("Failed to update feature.");
    }
  };

  return (
    <div className="">
      <div className='flex items-center'>
        <button onClick={() => setEditPakej(false)}>
          <FaAngleLeft className='text-4xl mr-4' />
        </button>
        <h1 className="text-3xl font-bold mb-4">Edit Pakej</h1>
      </div>
      <form onSubmit={handleSubmit} className="max-w-3xl">
  
        {/* Text Fields */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Pakej</label>
          <input
            type="text"
            name="pakej"
            value={formData.pakej}
            onChange={handleChange}
            className="mt-1 p-2 w-full border rounded-md capitalize"
            required
          />
        </div>
        
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Sale Price</label>
          <input
            type="number"
            name="sale_price"
            value={formData.sale_price}
            onChange={handleChange}
            className="mt-1 p-2 w-full border rounded-md"
            required
          />
        </div>
  
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Normal Price</label>
          <input
            type="number"
            name="normal_price"
            value={formData.normal_price}
            onChange={handleChange}
            className="mt-1 p-2 w-full border rounded-md"
            required
          />
        </div>
  
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Woocommerce Product ID</label>
          <input
            type="number"
            name="product_id"
            value={formData.product_id}
            onChange={handleChange}
            className="mt-1 p-2 w-full border rounded-md"
            required
          />
        </div>
  
        {/* Toggle Buttons */}
        {[
          "tema",
          "music",
          "contacts",
          "direction",
          "countdown",
          "rsvp",
          "money_gift",
          "guestbook",
          "galleries",
          "pdf",
        ].map((field) => (
          <div key={field} className="flex justify-between items-center p-2 border rounded-md">
            <span className="capitalize">{field.replace("_", " ")}</span>
            <button
              type="button"
              onClick={() => handleToggle(field)}
              className={`w-12 h-6 flex items-center rounded-full p-1 transition ${
                formData[field] === 1 ? "bg-green-500" : "bg-gray-300"
              }`}
            >
              <div
                className={`w-5 h-5 bg-white rounded-full shadow-md transform transition ${
                  formData[field] === 1 ? "translate-x-6" : ""
                }`}
              ></div>
            </button>
          </div>
        ))}
  
        <button type="submit" className="w-full bg-button1 text-b1Text mt-4 py-2 rounded-lg hover:bg-button1Hover transition">
          Save Changes
        </button>
      </form>
    </div>
  );
};

export default EditFeature;
